export default {
    url: 'ecocredits-monthly-madness',
    include: ['us', 'ca', 'eu', 'uk', 'de', 'fr', 'it', 'es'],
};
